import { Protocol } from '../../types/sharedTypeImpl';
import { Change } from './change';


export function getProgramsChanges(oldProtocol: Protocol, newProtocol: Protocol): Change[] {
    const changes: Change[] = [];

    const oldPrograms = oldProtocol.programs || [];
    const newPrograms = newProtocol.programs || [];

    const addedPrograms = newPrograms.filter((program) => !oldPrograms.includes(program));
    const removedPrograms = oldPrograms.filter((program) => !newPrograms.includes(program));

    const path = ['Program names'];
    for (const program of addedPrograms) {
        changes.push({
            path,
            changeDescription: program,
            changeType: 'add',
        });
    }
    for (const program of removedPrograms) {
        changes.push({
            path,
            changeDescription: program,
            changeType: 'remove',
        });
    }
    return changes;
}
